import React from 'react';

import { Box, LinearProgress, Stack, Typography } from '@mui/material';

interface Props {
  label: string;
  value: number | null;
}

export default function CurationScoreBar({ label, value }: Props) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body2">{label}</Typography>
        <Typography variant="body2" fontWeight="bold">
          {value != null ? `${value}/100` : 'N/A'}
        </Typography>
      </Stack>
      <LinearProgress
        variant="determinate"
        value={value ?? 0}
        color={value == null ? 'inherit' : value >= 70 ? 'success' : value >= 40 ? 'warning' : 'error'}
        sx={{ height: 8, borderRadius: 1, opacity: value == null ? 0.3 : 1 }}
      />
    </Box>
  );
}
